import React, { useState, Fragment } from "react";

const DropdownSearchable = (props) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(props.options);
  const [selectedOption, setSelectedOption] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleSearch = (e) => {
    props.setEnteredSearchField(e.target.value);

    const newSearchTerm = e.target.value;
    setSearchTerm(newSearchTerm);

    // const filtered = props.options.filter((option) =>
    //   option.toLowerCase().includes(newSearchTerm.toLowerCase())
    // );

    // setFilteredOptions(filtered);
  };

  const handleSelectOption = (option) => {
    props.onSelectedItem(option);
    setSelectedOption(option);
    setIsOpen(false);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const [selectedSearchType, setselectedSearchType] = useState("");

  const handleChange = (e) => {
    setselectedSearchType(e.target.value);
    props.setSelectedValue(e.target.value);
  };

  const [selectedSearchStyle_Customer, setSelectedSearchStyle_Customer] =
    useState();

  const inputSearchStyle_selected = {
    // color: "blue",
    backgroundColor: "lightgray",
    //marginBottom: "30px",
    float: "left",
  };
  const inputSearchStyle_Notselected = {
    //marginBottom: "30px",
    float: "left",
  };

  const handleOnFocusSearchField_Customer = (e) => {
    setSelectedSearchStyle_Customer(inputSearchStyle_selected);
  };

  const handleOnLossFocusSearchField_Customer = (e) => {
    setSelectedSearchStyle_Customer(inputSearchStyle_Notselected);
    //setIsOpen(false);
  };

  return (
    <Fragment>
      <div className="dropdown-container">
        <div style={{ float: "left" }}>
          <input
            style={{ ...props.style, ...selectedSearchStyle_Customer }}
            type="text"
            placeholder={props.placeholder}
            value={searchTerm}
            onChange={handleSearch}
            onClick={toggleDropdown}
            aria-label="Search Dashboard"
            onFocus={handleOnFocusSearchField_Customer}
            onBlur={handleOnLossFocusSearchField_Customer}
          />
        </div>
        <div
          style={{
            fontSize: "18px",
            color: "blue",
            marginLeft: "5px",
            marginTop: "3px",
            float: "left",
          }}
        >
          {props.isLoading && (
            <i
              className="fa fa-spinner fa-spin"
              style={{ fontSize: "24px" }}
            ></i>
          )}
          {!props.isLoading && props.options.length}
        </div>

        <div style={{ clear: "both" }}></div>

        {isOpen && (
          <ul className="menuDDL">
            {props.options.map((option, index) => (
              <li key={index} onClick={() => handleSelectOption(option)}>
                <a href="#">
                  {option.cellNo +
                    " [" +
                    option.name +
                    "] " +
                    " [" +
                    option.address +
                    " ]"}
                </a>
              </li>
            ))}
          </ul>
        )}
        {selectedOption && (
          <div className="selected-option">Selected: {selectedOption.name}</div>
        )}
      </div>
    </Fragment>
  );
};

export default DropdownSearchable;
